(function () {'use strict';}());
angular.module("elidb").directive('resultsMainView', function($document,$timeout) {
    return {
    	
    	restrict: 'A',
      templateUrl: __DIR__+'/views/results-main.html',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;
        $timeout(initialize, 0);

        function initialize(){

        	 $scope.limit = 25;
        	 $scope.$watch("limit", onUpdate);
        	 $scope.$watch("results", onChange);
        }
        function onChange(){
        	if($scope.results.length < $scope.limit){
        		$scope.view = $scope.results.length;
        	} else {
        		$scope.view = $scope.limit;
      		}

        }
        function onUpdate(){
        	$scope.limit = $scope.limit;
        	if($scope.limit <= $scope.results.length){
        		$scope.view = $scope.limit;
        	} else {
        		$scope.view = $scope.results.length;
        	}
        }
      }  
    };
  });